import React, { useEffect } from 'react';
import { Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getAllPosts } from '../blog';

const SITE_URL = 'https://www.workbees.space';

const Blog: React.FC = () => {
  const posts = getAllPosts();

  useEffect(() => {
    document.title = '博客 | Teegal';
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', `${SITE_URL}/blog`);
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-800">
      <Navbar />

      <header className="pt-32 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-3">博客</h1>
          <p className="text-slate-500">关于 AI 训练、模型与应用的实践笔记</p>
        </div>
      </header>

      <main className="pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto space-y-4">
          {posts.length === 0 && (
            <p className="text-slate-400 text-center py-20">还没有文章</p>
          )}
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="block p-6 rounded-2xl bg-white border border-slate-100 hover:border-indigo-200 hover:shadow-lg transition-all duration-300"
            >
              <h2 className="text-lg font-semibold text-slate-800 mb-2 group-hover:text-indigo-600">
                {post.title}
              </h2>
              {post.description && (
                <p className="text-sm text-slate-500 leading-relaxed mb-3">{post.description}</p>
              )}
              <div className="flex items-center gap-1.5 text-xs text-slate-400">
                <Calendar size={13} />
                <span>{post.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Blog;
